module.exports = __webpack_public_path__ + "img/banner4.ac007317.png";